module.exports = __webpack_public_path__ + "img/questionmark.d5ec0c34.svg";